export const scanToPay = {
  'scan-to-pay': 'Scan to pay',
  'scan-to-pay-disabled': 'Scan to pay - coming soon',
  'scan-to-pay.pass-existing': 'The sweetgreen pass is already in your wallet.',

  // ─── Scan To Pay Errors ──────────────────────────────────────────────

  'scan-to-pay.pass-failure': 'The sweetgreen pass could not be loaded.',
};
